<template>
  <div>
    <Button
      @click="toggle"
      icon="pi pi-external-link"
      iconPos="right"
      label="Ansicht in Vollbild"
    />
    <div class="example">
      <Belegungsplan
        :studioBezeichner="studio"
        :datum="heute"
        :fullscreen="fullscreen"
        :zufaellig="true"
      />
    </div>
  </div>
</template>
<script>
import fullscreen from "vue-fullscreen";
import { default as moment } from "moment-timezone";
import Vue from "vue";
import { currentTimestamp, TIMEZONE } from "@/api/Termine";
Vue.use(fullscreen);
export default {
  watch: {
    "$route.params.studio": function(studio) {
      console.debug("STP / Studio-Bezeichner wechselt: " + studio);
      this.studio = studio;
    },
  },
  created() {
    this.studio = this.$route.params.studio;
  },
  mounted() {
    this.studio = this.$route.params.studio;
  },
  computed: {
    darfTageAuswaehlen() {
      return this.$znaApi.darfTageAuswaehlen();
    },
    heute() {
      let gewaehltesDatum = "";
      if (this.darfTageAuswaehlen && this.$route.params.datum) {
        gewaehltesDatum = moment(this.$route.params.datum).tz(TIMEZONE).format();
      } else {
        gewaehltesDatum = currentTimestamp().format();
      }
      return gewaehltesDatum;
    },
  },
  methods: {
    toggle() {
      this.$fullscreen.toggle(this.$el.querySelector(".example"), {
        wrap: true,
        callback: this.fullscreenChange,
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
  },
  data() {
    return {
      studio: "",
      fullscreen: false,
    };
  },
};
</script>
